import React from 'react'
import { connect } from 'react-redux'
import EdicionDemoraEnVolcadora from './EdicionDemoraEnVolcadora'
import DeleteDemoraEnVolcadora from './DeleteDemoraEnVolcadora'
import { reduxForm } from 'redux-form'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { FORM_PRODUCTIVIDAD_VOLCADORAS } from '../../../../config/forms'
import { deleteDemoraEnVolcadora, updateDemoraEnVolcadora } from '../../actions/EstadisticasVolcadorasActions'

function OperacionesDemoraEnVolcadoras (props) {
  const { data, motivosDemora } = props

  const deleteDemora = () => {
    props.deleteDemoraEnVolcadora(data.inicioDeDemora, data.volcadoraCamiones)
  }

  const updateDemora = () => {
    console.log('data ', data)
    props.updateDemoraEnVolcadora(data.inicioDeDemora, data.volcadoraCamiones)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <EdicionDemoraEnVolcadora
        data={data}
        motivosDemora={motivosDemora}
        updateDemora={updateDemora}
      />
      <DeleteDemoraEnVolcadora deleteDemora={deleteDemora} />
    </>
  )
}

const mapStateToProps = (state) => ({
  motivosDemora: state.volcadora.motivosDemoraVolcadora
})

const mapActionsToProps = {
  deleteDemoraEnVolcadora,
  updateDemoraEnVolcadora
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_PRODUCTIVIDAD_VOLCADORAS
})

export default withRedux(withReduxForm(OperacionesDemoraEnVolcadoras))
